import React from 'react';
import { dateToHumanString } from '../utils/DateUtils';
import {Table, TableBody, TableFooter, TableHeader, TableHeaderColumn, TableRow, TableRowColumn}
  from 'material-ui/Table';

export default (props) => {
  return (
    <div>
      <Table
        fixedHeader={true}
        fixedFooter={true}
        selectable={false}
        multiSelectable={false}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          enableSelectAll={false}
        >
          <TableRow>
            <TableHeaderColumn colSpan="5" tooltip="Super Header" style={{textAlign: 'center'}}>
              Latest Orders
            </TableHeaderColumn>
          </TableRow>
          <TableRow>
            <TableHeaderColumn tooltip="Date order was placed">Date</TableHeaderColumn>
            <TableHeaderColumn tooltip="Customer name">Customer</TableHeaderColumn>
            <TableHeaderColumn tooltip="Whether order has been paid or not">Payment Status</TableHeaderColumn>
            <TableHeaderColumn tooltip="Fullfilment status">Fullfilment Status</TableHeaderColumn>
            <TableHeaderColumn tooltip="Net Total for order">Total</TableHeaderColumn>
          </TableRow>
        </TableHeader>
        <TableBody
          displayRowCheckbox={false}
          deselectOnClickaway={true}
          showRowHover={true}
          stripedRows={false}
        >
          {props.orders.map( (row, index) => (
            <TableRow key={index} selected={row.selected}>
              <TableRowColumn>{dateToHumanString(row.createdAt.seconds)}</TableRowColumn>
              <TableRowColumn>{`${row.user && row.user.firstName} ${row.user && row.user.lastName}`}</TableRowColumn>
              <TableRowColumn>{row.charged ? 'Paid' : 'Unpaid'}</TableRowColumn>
              <TableRowColumn>{row.status}</TableRowColumn>
              <TableRowColumn>${row.total.toFixed(2)}</TableRowColumn>
            </TableRow>
            ))}
        </TableBody>

      </Table>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/OrderList.js